/* global console */
const moment = require('moment');
/*
 * API to write logs based on traditional logging mechanisms: debug, trace, info, warning, error
 */

const Logger = (() => {
    const DEBUG = 0;
    const TRACE = 1;
    const INFO = 2;
    const WARNING = 3;
    const ERROR = 4;
    const NONE = 5;
    let logPrefix = '';
    let outputFunction;
    const setLogIE = () => {
        if (!window.console) {
            const console = {
                log() { },
                warn() { },
                error() { },
                time() { },
                timeEnd() { },
            };
        }
    };
    setLogIE();
    // It sets the new log level. We can set it to NONE if we do not want to print logs
    const setLogLevel = (level) => {
        if (typeof level === "string" || typeof level === "number") {
            let targetLevel = level;
            if (typeof targetLevel === "number") {
                targetLevel = Math.round(level);
                if (level > Logger.NONE) {
                    targetLevel = Logger.NONE;
                } else if (level < Logger.DEBUG) {
                    targetLevel = Logger.DEBUG;
                }
                Logger.logLevel = targetLevel;
            }
            else {
                var arr = ["DEBUG", "TRACE", "INFO", "WARNING", "ERROR", "NONE"]
                if (arr.indexOf(targetLevel) > -1) {
                    Logger.logLevel = targetLevel;
                }
                else {
                    Logger.error('setLogLevel() invalid param');
                }
            }
        }
        else {
            Logger.error('setLogLevel() invalid param type');
        }
    };

    const getLogLevel = (level) => {
        return Logger.logLevel;
    };

    outputFunction = (args) => {
        // eslint-disable-next-line no-console
        console.log(...args);
    };

    const setOutputFunction = (newOutputFunction) => {
        outputFunction = newOutputFunction;
    };

    const setLogPrefix = (newLogPrefix) => {
        logPrefix = newLogPrefix;
    };
    const setLogCache = (keyValue, arg) => {
        if (localStorage != undefined && localStorage != null) {
            const logData = (localStorage.getItem('vcxRTCLib-log') !== null) ? JSON.parse(localStorage.getItem('vcxRTCLib-log')) : {};

            const length = Object.keys(logData).length;
            if (length > 500) {
                delete (Object.keys(logData)[0]);
            }
            let logString = '';
            for (const i in arg) {
                if (typeof arg[i] === 'object') {
                    logString += JSON.stringify(arg[i], null, 2);
                } else {
                    logString += arg[i];
                }
            }
            logData[keyValue] = logString;
            if (localStorage.getItem('vcxRTCLib-log') !== null) {
                localStorage.removeItem('vcxRTCLib-log');
            }
            localStorage.setItem('vcxRTCLib-log', JSON.stringify(logData, null, 2));
        }
    };
    // Generic function to print logs for a given level:
    //  Logger.[DEBUG, TRACE, INFO, WARNING, ERROR]
    const log = (level, ...args) => {
        setLogPrefix(`${moment().format('YYMMDDHHmmss')}::`);
        let out = logPrefix;
        if (level < Logger.logLevel) {
            return;
        }
        if (level === Logger.DEBUG) {
            out = `${out}D`;
        } else if (level === Logger.TRACE) {
            out = `${out}T`;
        } else if (level === Logger.INFO) {
            out = `${out}I`;
        } else if (level === Logger.WARNING) {
            out = `${out}W`;
        } else if (level === Logger.ERROR) {
            out = `${out}E`;
        }
        out = `${out}::WB::`;
        if (localStorage != undefined && localStorage != null) {
            out += ((localStorage.getItem('logID') !== null) ? `${localStorage.getItem('logID')}::` : '');
        }
        const tempArgs = [out].concat(args);
        setLogCache(out, args);
        if (Logger.panel !== undefined) {
            let tmp = '';
            for (let idx = 0; idx < tempArgs.length; idx += 1) {
                tmp += tempArgs[idx];
            }
            Logger.panel.value = `${Logger.panel.value}\n${tmp}`;
        } else {
            outputFunction.apply(Logger, [tempArgs]);
        }
    };

    const debug = (...args) => {
        Logger.log(Logger.DEBUG, ...args);
    };

    const trace = (...args) => {
        Logger.log(Logger.TRACE, ...args);
    };

    const info = (...args) => {
        Logger.log(Logger.INFO, ...args);
    };

    const warning = (...args) => {
        Logger.log(Logger.WARNING, ...args);
    };

    const error = (...args) => {
        Logger.log(Logger.ERROR, ...args);
    };

    return {
        DEBUG,
        TRACE,
        INFO,
        WARNING,
        ERROR,
        NONE,
        setLogLevel,
        getLogLevel,
        setOutputFunction,
        setLogPrefix,
        log,
        debug,
        trace,
        info,
        warning,
        error,
    };
})();

export default Logger;



//////////////////
// WEBPACK FOOTER
// ./src/utils/Logger.js
// module id = 1
// module chunks = 0